export default "__VITE_ASSET__75f1fb25__"